import Image from 'next/image'
import koerperfitLogo from './koerperfit.png'

type IconProps = {
  className?: string
}

const KoerperfitLogo: React.FC<IconProps> = ({ ...attributes }) => {
  return <Image src={koerperfitLogo} alt="Koerperfit Logo" height={48} {...attributes} />
}

export default KoerperfitLogo
